import bugsnag from '@bugsnag/js';

if(process.env.NODE_ENV === 'production') {
  bugsnag.start('9f17b291a8a3869ce535ff629d3d69f1')
}

/**
 * Report a handled error with some context attached.
 *
 * Bugsnag only starts in production, and `notify` before `start` throws — so a
 * call site that reports a failure it has already recovered from would turn a
 * recovered failure into a crash everywhere else. This no-ops instead, and
 * never lets the reporting itself become the error.
 */
export function reportHandledError(error: unknown, context: Record<string, unknown> = {}): void {
  try {
    if (!bugsnag.isStarted()) return;

    bugsnag.notify(error instanceof Error ? error : new Error(String(error)), (event) => {
      event.severity = 'warning';
      event.unhandled = false;
      // Not 'context': Bugsnag already has a top-level event.context, and a
      // metadata tab by the same name reads as the same thing in the UI.
      event.addMetadata('details', context);
    });
  } catch {
    // Telemetry must never break the flow it is reporting on.
  }
}
